/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs.js'

const $nsid = 'app.bsky.unspecced.initAgeAssurance'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  email: /*#__PURE__*/ l.string(),
  language: /*#__PURE__*/ l.string(),
  countryCode: /*#__PURE__*/ l.string(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<UnspeccedDefs.AgeAssuranceState>(
    (() => UnspeccedDefs.ageAssuranceState) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Initiate age assurance for an account. This is a one-time action that will start the process of verifying the user's age. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidEmail',
  'DidTooLong',
  'InvalidInitiation',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
